import { render } from "./Sidebar.vue?vue&type=template&id=2a03fcaf&scoped=true"
import script from "./Sidebar.js?vue&type=script&lang=js"
export * from "./Sidebar.js?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=2a03fcaf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a03fcaf"]])

export default __exports__